import { isObject, isArray, isBoolean, isEmptyArray, isEmptyObj } from './index';
import dayjs from 'dayjs'
import download from 'downloadjs'

// 通过JSON深拷贝
export const deepCloneByJSON = (data: any) => {
  if (Array.isArray(data) || isObject(data)) {
    return JSON.parse(JSON.stringify(data))
  } else {
    return data
  }
}

export const clearData = (data: any) => {
  if (isObject(data)) {
    for (let key in data) {
      if (isObject(data[key])) {
        clearData(data[key])
      } else if (isArray(data[key])) {
        data[key] = []
      } else if (isBoolean(data[key])) {
        data[key] = false
      } else {
        data[key] = ''
      }
    }
  }
}

/**
 * 将对象数组转为键值对对象
 * @param {Array[Object]} arr 原对象数组
 * @param {String} key             对象的key
 * @param {String} value           对象的value
 * @returns {Object}
 */
export const arrToObj = (arr = [], labelKey = 'label', valueKey = 'value') => {
  if (isEmptyArray(arr)) return {}
  return arr.reduce((p, c) => {
    p[c[labelKey]] = c[valueKey]
    return p
  }, {})
}


/**
 * 将对象转为键值对对象数组
 */
export const objToArr = (obj: DefaultObjectType, labelKey = 'label', valueKey = 'value') => {
  if (isEmptyObj(obj)) return []
  return Object.keys(obj).map(key => {
    return {
      [labelKey]: key,
      [valueKey]: obj[key]
    }
  })
}


export const Storage = {
  // 设置缓存
  sessionSet: function (name, data) {
    sessionStorage.removeItem(name)
    sessionStorage.setItem(name, JSON.stringify(data))
  },
  // 获取缓存
  sessionGet: function (name) {
    return JSON.parse(sessionStorage.getItem(name))
  },
  // 清除缓存
  sessionRemove: function (name) {
    sessionStorage.removeItem(name)
  },
  // ==================localStorage设置缓存==================
  // 设置缓存
  localSet: function (name, data) {
    localStorage.removeItem(name)
    localStorage.setItem(name, JSON.stringify(data))
  },
  // 获取缓存
  localGet: function (name) {
    return JSON.parse(localStorage.getItem(name))
  },
  // 清除缓存
  localRemove: function (name) {
    localStorage.removeItem(name)
  },
}

/**
 * 获取特定字段的数组
 * @param {Array[Object]} data  原对象数组
 * @param {String} key          对象的key
 * @returns {Array}
 */
export const getArrByReduce = (data, key) => {
  return !isEmptyArray(data)
    ? data.reduce((p, c) => {
      (!isEmptyObj(c)) && p.push(c[key])
      return p
    }, [])
    : []
}


/**
 * 对象数组去重
 * @param {*} arr   数组
 * @param {*} id    对象中唯一的id值
 * @returns
 */
export const unique = (arr, id) => {
  let object = {}
  let copyArr = arr.reduce((item, next) => {
    object[next[id]] ? '' : (object[next[id]] = true && item.push(next))
    return item
  }, [])
  return copyArr
}


// 节流函数
export const throttle = (handler, wait) => {
  let lastTime = 0
  return function (e) {
    let nowTime = new Date().getTime()
    if (nowTime - lastTime > wait) {
      handler.apply(this, arguments)
      lastTime = nowTime
    }
  }
}

export const getItemByProp = (resource, prop) => resource.flat().find(item => item.prop === prop);


// 时间戳转零时区
export const transferTime = (timeStamp) => {
  let timezone = 0 //目标时区：0
  let offset_GMT = new Date().getTimezoneOffset() // 本地时间和格林威治的时间差，单位为分钟
  let targetDate = new Date(timeStamp + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000)
  console.log("targetDate", dayjs(targetDate).format('YYYY-MM-DD hh:mm:ss'));
  return dayjs(targetDate).format('YYYY-MM-DD hh:mm:ss')
}





// 防抖函数
export const debounce = (handle, delay) => {
  let timer = null
  return function () {
    let _self = this,
      _args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      handle.apply(_self, _args)
    }, delay)
  }
}


/**
 * 清除空数据
 * @param {*} obj
 * @returns
 */
export const removePropertyOfNull = function (obj) {
  Object.keys(obj).forEach((item) => {
    if (obj[item] === 0) { }
    else if (!obj[item] || obj[item] == '') delete obj[item]
  })
  return obj
}


export const downloadFile = (url, fileName?, type?) => {
  // console.log(fileName)
  // 获取heads中的filename文件名
  let downloadElement = document.createElement('a')

  // 创建下载的链接
  downloadElement.href = url
  // 下载后文件名
  downloadElement.download = fileName || ''
  downloadElement.target = type || '_blank'
  document.body.appendChild(downloadElement)
  // 点击下载
  downloadElement.click()
  // 下载完成移除元素
  document.body.removeChild(downloadElement)
  // 释放掉blob对象
  // window.URL.revokeObjectURL(href)
}

/**
 * 文件下载方法
 * @param {*} file 文件数据
 * @param {*} fileName 文件名称
 * @param {*} fileType 文件类型
 */
export const fileDownload = (file, fileName, fileType) => {
  download(file, fileName, fileType)
}


// 滚动定位到form表单首个校验失败的位置
export const scrollIntoView = (className = "is-error", block: any = "center") => {
  Promise.resolve().then(() => {
    const target = document.getElementsByClassName(className);
    if (target.length) {
      target[0].scrollIntoView({
        behavior: "smooth", // 平滑过渡 值有auto、instant,smooth，缓动动画（当前是慢速的）
        block: block, // 上边框与视窗顶部平齐。默认值 值有start,center,end，nearest，当前显示在视图区域中间
      })
    }
  });
};

// 获取url参数
export const getUrlParams = (route) => {
  const { query } = route
  return query || {}
}

/**
 *  将以逗号分割字符串id转换成对应字段以逗号分割,人能看懂的文字
 * @param str 以逗号分割的字符串
 * @param list 遍历数组数据
 * @param key  判断的键的名称
 * @param name  需要返回显示数组数据的键名称
 * @returns 
 */
export const formateStr = (str: string, list: Array<[]>, key?: string , name?: string) => {
  if (str) {
    let arr = str.split(',')
    let res = []
    arr.forEach(item => {
      list.forEach(listItem => {
        if (listItem[key || 'id'] == item) {
          res.push(listItem[name || 'name'])
        }
      })
    })
    return res.join()
  }
  return ''
}

/** 将url的query参数转化为对象形式 */
export const parseQueryString = (url) => {
  const searchParams = new URLSearchParams(url.split('?')[1]);
  const obj = {};
  for (let [key, value] of searchParams.entries()) {
    obj[key] = value;
  }
  return obj;
}

/** 找到传入数组对应的label */
export const findLabel = (dataList, value) => {
  let label = ''
  dataList.forEach(item => {
    if(item.value == value){
      label = item.label
    }
  })
  return label
}


interface ITreeIterator {
  label: string;
  children: any[]
}
/** 合并树形结构,将label相同的节点合并 */
export const  treeIterator = (tree: ITreeIterator[]) => {
  const arr: ITreeIterator[] = []
  if (!Array.isArray(tree) || !tree.length) return arr
  tree.forEach((e: ITreeIterator) => {
    const index = arr.findIndex(i => i.label == e.label)
    if (index > -1) {
      arr[index].children = treeIterator([...arr[index].children, ...e.children])
    } else {
      arr.push({ ...e, children: treeIterator(e.children) })
    }
  });

  return arr;
}

// 判断两个数组是否有交集
export const intersect = (arr1=[], arr2=[]) => {
  return arr1?.some(item => arr2.includes(item))
}

// 下载base64文件
export const downBase64File = (str, name) => {
  let raw = window.atob(str);
  let uInt8Array = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  let link = new Blob([uInt8Array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  let url = URL.createObjectURL(link);
  let fileLink = document.createElement('a');
  fileLink.href = url;
  fileLink.setAttribute('download', name);
  document.body.appendChild(fileLink);
  fileLink.click();
  URL.revokeObjectURL(url)
  document.body.removeChild(fileLink)
}

// 判断数组中的数字是否连续
export const isConsecutive = (nums) => {
    // 如果数组长度小于2，则无法构成连续序列
    if (nums.length < 2) {
        return true;
    }
    // 将数组排序
    nums.sort((a, b) => a - b);
    // 检查相邻数字之间的差值是否为1
    for (let i = 0; i < nums.length - 1; i++) {
        if (nums[i + 1] - nums[i] !== 1) {
            return false;
        }
    }
    // 如果所有相邻数字之间的差值都为1，则数组是连续的
    return true;
}


// 格式化json数据，便于阅读和理解
export const formattedJson = (jsonString) => {
  try {
    const jsonObject = JSON.parse(jsonString);
    return JSON.stringify(jsonObject, null, 2); // 格式化 JSON 字符串，缩进为 2 个空格
  } catch (e) {
    return 'Invalid JSON string';
  }
}

// 根据语言的简写，获取全称
export const getLanguageFullName = (key, langOptions) => {
  if(!langOptions || !langOptions.length) return ''

  let findItem = langOptions.filter(item=> item.code == key || item.name == key) // item.name防止传入全称报错
  if(findItem) return findItem[0].name?findItem[0].name: ''
}

// 格式化百分比函数
export const formatPercentage = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined || value === '') {
    return '--'
  }
  const numValue = typeof value === 'string' ? parseFloat(value) : value
  if (isNaN(numValue)) {
    return '--'
  }
  // 转换为百分比
  const percentage = numValue * 100
  // 如果是0或整数，直接返回不带小数的百分比
  if (percentage === 0 || percentage % 1 === 0) {
    return `${percentage}%`
  }
  // 否则保留两位小数
  return `${percentage.toFixed(2)}%`
}

/**
 * 通用导出方法
 * @param {Object} options 配置选项
 * @param {Object} options.params 请求参数（由外部处理好的参数对象）
 * @param {String} options.apiUrl API 地址
 * @param {String} options.fileName 文件名前缀
 * @param {Ref} options.loadingRef loading 状态的 ref 对象（可选）
 * @param {Function} options.liveInstance live_instance 函数
 * @returns {Promise}
 */
export const handleCommonExport = async (options: {
  params: any
  apiUrl: string
  fileName: string
  loadingRef?: any
  liveInstance: any
}) => {
  const {
    params,
    apiUrl,
    fileName,
    loadingRef,
    liveInstance
  } = options

  try {
    // 设置 loading 状态
    if (loadingRef) {
      loadingRef.value = true
    }

    const res: any = await liveInstance({
      method: 'get',
      url: apiUrl,
      params,
      responseType: 'blob'
    })

    // 如果文件名已经包含 .xlsx，说明已经包含日期，直接使用；否则添加当前日期
    const finalFileName = fileName.endsWith('.xlsx') 
      ? fileName 
      : `${fileName}_${dayjs().format('YYYY-MM-DD')}.xlsx`
    fileDownload(res, finalFileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
  } catch (error) {
    console.error('导出失败', error)
  } finally {
    // 重置 loading 状态
    if (loadingRef) {
      loadingRef.value = false
    }
  }
}

// 时间维度类型（目前有 time、day，保留 string 以兼容其他未定义值）
type TimeDimension = '30min' | 'day' | string

interface QueryTimeRangeParams {
  // 时间维度：30min 表示时间段，day 表示日期范围
  dimension: TimeDimension
  // 日期范围（如 ['2024-01-01', '2024-01-07']）
  dateRange?: string[]
  // 单独日期（时间段模式下使用）
  date?: string
  // 开始、结束时间（HH:mm）
  startTime?: string
  endTime?: string
}

/**
 * 根据不同时间维度生成接口需要的 startTime、endTime
 * - 时间段模式：使用单独日期 + start/endTime
 * - 日期模式：将日期范围与 00:00 / 23:59 组合
 */
export const generateQueryTimeRange = (params: QueryTimeRangeParams) => {
  const {
    dimension,
    dateRange,
    date,
    startTime,
    endTime
  } = params

  const formatDateTimeValue = (dateStr?: string, timeStr?: string) => {
    if (!dateStr) return ''
    return `${dateStr} ${timeStr || '00:00'}`
  }

  if (dimension === '30min') {
    const baseDate = date || dayjs().format('YYYY-MM-DD')
    return {
      startTime: formatDateTimeValue(baseDate, startTime || '00:00'),
      endTime: formatDateTimeValue(baseDate, endTime || '23:59')
    }
  }

  const [rangeStart, rangeEnd] = dateRange || []
  return {
    startTime: rangeStart ? formatDateTimeValue(rangeStart, '00:00') : '',
    endTime: rangeEnd ? formatDateTimeValue(rangeEnd, '00:00') : ''
  }
}

/**
 * 根据预设类型生成日期范围
 * - yesterday：昨天到今天
 * - 7 / 30 / 90：过去 N 天到今天
 * - 其他：返回空数组
 */
export const makeRangeByType = (type: string) => {
  const end = dayjs().format('YYYY-MM-DD')
  if (type === 'yesterday') {
    const start = dayjs().subtract(1, 'day').format('YYYY-MM-DD')
    return [start, end]
  }
  if (['7', '30', '90'].includes(type)) {
    const days = Number(type) - 1
    const start = dayjs().subtract(days, 'day').format('YYYY-MM-DD')
    return [start, end]
  }
  return []
}


/**
 * 生成「过去两小时」的默认查询区间
 * - 结束时间取当前时间往前回退到最近的半小时节点（15:45 -> 15:30）
 * - 起始时间再往前推 2 小时，若跨天则回退到当日 00:00
 * - 返回同一天的日期，方便时间段查询组装 YYYY-MM-DD HH:mm
 */
export const getRecentTwoHoursRange = () => {
  const now = dayjs()
  const minute = now.minute()
  const flooredMinute = minute >= 30 ? 30 : 0
  const endTimePoint = now.minute(flooredMinute).second(0).millisecond(0)
  const startTimePoint = endTimePoint.subtract(2, 'hour')
  const dayStart = endTimePoint.startOf('day')
  const adjustedStart = startTimePoint.isBefore(dayStart) ? dayStart : startTimePoint
  return {
    date: endTimePoint.format('YYYY-MM-DD'),
    startTime: adjustedStart.format('HH:mm'),
    endTime: endTimePoint.format('HH:mm')
  }
}







